import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "golden-beach",
  name: "Golden Beach",
  title: "Golden Beach lawyers and conveyancers",
  metaTitle: `Golden Beach Lawyers & Conveyancing | ${FIRM.name}`,
  description: `Coastside Law is based in Golden Beach. Fixed-fee conveyancing (${FEES.sale} incl. GST on sales), wills, estates and elder law for Golden Beach residents. Call ${FIRM.phone}.`,
  lead: "We are not just servicing Golden Beach — we are in it. Our office is on Theresa Street, and Erin lives in the suburb. If you want a lawyer who can picture the street your property is on, that is us.",
  paragraphs: [
    "Golden Beach runs along the Pumicestone Passage from the Caloundra Bar down toward Bells Creek, and it has changed a great deal over the last decade. Original beach shacks sit beside new builds, older canal and waterfront homes trade at strong prices, and there is a steady stream of retirees downsizing in and out of the suburb.",
    "That mix produces particular legal work: contracts on older homes with additions that may never have been approved, deceased estate sales where the executor needs probate before settlement, and downsizers who want their will and power of attorney sorted at the same time as the move.",
    "We handle all of it on fixed fees, and we are close enough that a home appointment is easy to arrange.",
  ],
  person: "erin-wilkinson",
  localNotes: [
    {
      t: "Unapproved additions",
      d: "Enclosed under-house areas, decks and carports added over the years without council approval are common on older Golden Beach blocks. They show up in a building and pest report and need to be dealt with before settlement, not after.",
    },
    {
      t: "Waterfront and canal frontage",
      d: "Revetment walls, pontoons and jetty approvals are part of the title picture on passage-front and canal properties. We check what is approved and who is responsible for maintenance.",
    },
    {
      t: "Flood and storm tide overlays",
      d: "Parts of the low-lying foreshore sit within Sunshine Coast Council flood and storm tide overlays, which affects insurance and future building. Worth knowing before you sign, not after.",
    },
    {
      t: "Deceased estate sales",
      d: "Selling an estate property requires the grant to be in hand. We run the probate application and the conveyance together so the settlement date is realistic.",
    },
  ],
  suburbs: ["Caloundra", "Pelican Waters", "Kings Beach", "Bells Creek", "Aroona", "Little Mountain"],
  faqs: [
    {
      q: "Do you meet clients in Golden Beach?",
      a: `Yes — our office is at ${FIRM.street}, Golden Beach, by appointment, and we will come to your home if that is easier. That is particularly common for wills and powers of attorney.`,
    },
    {
      q: "Do you handle canal-front and waterfront property?",
      a: "Yes. We check revetment wall obligations, pontoon and jetty approvals, and any body corporate or council conditions attaching to the water frontage.",
    },
    {
      q: "Can you help with a deceased estate property in Golden Beach?",
      a: "Yes. We handle the probate application and the sale as one matter, so the executor is not juggling two firms and two timelines.",
    },
  ],
};
